import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Popper, RaiseColors, ShadowContainer, Typography, Icon, makeStyles, ClickAwayListener, IconConstants } from "componentLibrary";
import { OVERLAY_MENU_Z_INDEX } from "utils/constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    popover: {
      borderRadius: 16,
      zIndex: 2
    },
    container: {
      display: "flex",
      flexDirection: "column",
      padding: "16px",
      maxWidth: "240px",
      borderRadius: "4px",
      zIndex: 2
    },
    iconWrapper: {
      display: "flex",
      alignItems: "center",
      gap: "4px"
    }
  };
});
var InfoIconPopper = function InfoIconPopper(_ref) {
  var title = _ref.title,
    _ref$titleVariant = _ref.titleVariant,
    titleVariant = _ref$titleVariant === void 0 ? "h4" : _ref$titleVariant,
    infoText = _ref.infoText,
    _ref$popperPlacement = _ref.popperPlacement,
    popperPlacement = _ref$popperPlacement === void 0 ? "top" : _ref$popperPlacement,
    _ref$iconFontSize = _ref.iconFontSize,
    iconFontSize = _ref$iconFontSize === void 0 ? 14 : _ref$iconFontSize,
    _ref$iconClass = _ref.iconClass,
    iconClass = _ref$iconClass === void 0 ? IconConstants.INFO_CIRCLE : _ref$iconClass,
    _ref$useMobile = _ref.useMobile,
    useMobile = _ref$useMobile === void 0 ? false : _ref$useMobile,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? RaiseColors.neutral500 : _ref$iconColor,
    _ref$popperChildStyle = _ref.popperChildStyles,
    popperChildStyles = _ref$popperChildStyle === void 0 ? {} : _ref$popperChildStyle,
    _ref$infoTextVariant = _ref.infoTextVariant,
    infoTextVariant = _ref$infoTextVariant === void 0 ? "paragraph_medium" : _ref$infoTextVariant,
    _ref$popperTextColor = _ref.popperTextColor,
    popperTextColor = _ref$popperTextColor === void 0 ? RaiseColors.glacier2400 : _ref$popperTextColor,
    postfixText = _ref.postfixText,
    _ref$disablePopover = _ref.disablePopover,
    disablePopover = _ref$disablePopover === void 0 ? false : _ref$disablePopover;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchorEl = _React$useState2[0],
    setAnchorEl = _React$useState2[1];
  var classes = useStyles();
  var handlePopoverOpen = function handlePopoverOpen(event) {
    if (!disablePopover) {
      setAnchorEl(event === null || event === void 0 ? void 0 : event.currentTarget);
    }
  };
  var handlePopoverClose = function handlePopoverClose() {
    if (!disablePopover) {
      setAnchorEl(null);
    }
  };
  var open = Boolean(anchorEl);
  return /*#__PURE__*/_jsx(ClickAwayListener, {
    onClickAway: handlePopoverClose,
    children: /*#__PURE__*/_jsxs("div", {
      style: _objectSpread({}, style),
      children: [/*#__PURE__*/_jsxs("div", {
        className: classes.iconWrapper,
        onMouseOver: useMobile || disablePopover ? undefined : handlePopoverOpen,
        onMouseOut: useMobile || disablePopover ? undefined : handlePopoverClose,
        onClick: useMobile && !disablePopover ? handlePopoverOpen : undefined,
        children: [/*#__PURE__*/_jsx(Icon, {
          className: iconClass,
          color: iconColor,
          fontSize: iconFontSize,
          style: {
            overflow: "visible"
          }
        }), postfixText !== null && postfixText !== void 0 ? postfixText : null]
      }), !disablePopover && /*#__PURE__*/_jsx(Popper, {
        open: open,
        anchorEl: anchorEl,
        placement: popperPlacement
        // Set z-index to 1400 to ensure this appears above MUI Modals (default z-index 1300).
        ,
        sx: {
          zIndex: OVERLAY_MENU_Z_INDEX
        },
        children: /*#__PURE__*/_jsxs(ShadowContainer, {
          className: classes.container,
          style: _objectSpread({}, popperChildStyles),
          children: [title && /*#__PURE__*/_jsx(Typography, {
            variant: titleVariant,
            weight: "semibold",
            style: {
              marginBottom: "8px"
            },
            color: popperTextColor,
            children: title
          }), /*#__PURE__*/_jsx(Typography, {
            variant: infoTextVariant,
            weight: "medium",
            color: popperTextColor,
            children: infoText
          })]
        })
      })]
    })
  });
};
export default InfoIconPopper;